export enum OTPMethod {
  PHONE = 'PHONE',
  EMAIL = 'EMAIL',
}
